// export function zipcodeRules(country) {
//     switch (country){
//         case "United States of America":
//         case "US":
//             let regexUS = /^\d{5}$|^\d{9}$/
//             return (rule,value,callback) => {
//                 if(value === ''){
//                     callback(new Error('Please enter the zipcode'))
//                 }else if(!regexUS.test(value)){
//                     callback(new Error('Please enter 5-digit or 9-digit zipcode'))
//                 }else{
//                     callback()
//                 }
//             }
//         case "Australia":
//         case "AU":
//             let regexAU = /^\d{4}$/
//             return (rule,value,callback) => {
//                 if(value === ''){
//                     callback(new Error('Please enter the zipcode'))
//                 }else if(!regexAU.test(value)){
//                     callback(new Error('Please enter 4-digit zipcode'))
//                 }else{
//                     callback()
//                 }
//             }
//         case "Canada":
//         case "CA":
//             let regexCA = /^[A-Za-z]\d[A-Za-z] \d[A-Za-z]\d$/
//             return (rule,value,callback) =>{
//                 if(value === ''){
//                     callback(new Error('Please enter the zipcode'))
//                 }else if(!regexCA.test(value)){
//                     callback(new Error('Please enter the correct zipcode'))
//                 }else{
//                     callback()
//                 }
//             }
//         case "United Kingdom":
//         case "UK":
//             let regexUK = /^[A-Za-z]{1,2}\d{1,2} ?\d[A-Za-z]{2}$/
//             return (rule,value,callback) => {
//                 if(value === ''){
//                     callback(new Error('Please enter the zipcode'))
//                 }else if(!regexUK.test(value)){
//                     callback(new Error('Please enter the correct zipcode'))
//                 }else{
//                     callback()
//                 }
//             }
//         case "New Zealand":
//         case "NZ":
//             let regexNZ = /^\d{4}$/
//             return (rule,value,callback) => {
//                 if(value === ''){
//                     callback(new Error('Please enter the zipcode'))
//                 }else if(!regexNZ.test(value)){
//                     callback(new Error('Please enter 4-digit zipcode'))
//                 }else{
//                     callback()
//                 }
//             }
//         default:
//             return;
//     }
// }

export function phoneRules(country) {
    switch(country){
        case "+1(US)":
        case "US":
            let regexUS =  /^\d{10}$/
            return (rule,value,callback) => {
                if(value === ''){
                    callback(new Error('Please enter the correct number'))
                }else if(!regexUS.test(value)){
                    callback(new Error('Please enter the correct number'))
                }else{
                    callback()
                }
            }
        case "+61(AU)":
        case "AU":
            let regexAU = /^\d{9}$/
            return (rule,value,callback) => {
                if(value === ''){
                    callback(new Error('Please enter the correct number'))
                }else if(!regexAU.test(value)){
                    callback(new Error('Please enter the correct number'))
                }else{
                    callback()
                }
            }
        case "+1(CA)":
        case "CA":
            let regexCA = /^\d{10}$/
            return (rule,value,callback) =>{
                if(value === ''){
                    callback(new Error('Please enter the correct number'))
                }else if(!regexCA.test(value)){
                    callback(new Error('Please enter the correct number'))
                }else{
                    callback()
                }
            }
        case "+44(UK)":
        case "UK":
            let regexUK = /^(?:0\d{9}|0\d{10}|\d{10}|\d{11})$/
            return (rule,value,callback) => {
                if(value === ''){
                    callback(new Error('Please enter the correct number'))
                }else if(!regexUK.test(value)){
                    callback(new Error('Please enter the correct number'))
                }else{
                    callback()
                }
            }
        case "+64(NZ)":
        case "NZ":
            let regexNZ = /^\d{8}$|^\d{9}$|^\d{10}$/
            return (rule,value,callback) => {
                if(value === ''){
                    callback(new Error('Please enter the correct number'))
                }else if(!regexNZ.test(value)){
                    callback(new Error('Please enter the correct number'))
                }else{
                    callback()
                }
            }
        default:
    }
}

export function zipcodeRules(){
    let regex = /^[a-zA-Z0-9]{1,10}$/
    return (rule,value,callback) => {
        if(!regex.test(value)){
            callback(new Error('Please enter the correct zipCode'))
        }else{
            // callback()
        }
    }
}




// WEBPACK FOOTER //
// ./src/components/validateRules.js